"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingsRequestFacetBuilder = exports.ListingsRequestFacetIntervalBuilder = void 0;
class ListingsRequestFacetIntervalBuilder {
    constructor() {
        this.data = {};
    }
    min(n, exclusive = false) {
        if (exclusive) {
            this.data.exclusiveMinimum = n;
        }
        else {
            this.data.minimum = n;
        }
        return this;
    }
    max(n, exclusive = false) {
        if (exclusive) {
            this.data.exclusiveMaximum = n;
        }
        else {
            this.data.maximum = n;
        }
        return this;
    }
    build() {
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestFacetIntervalBuilder = ListingsRequestFacetIntervalBuilder;
class ListingsRequestFacetBuilder {
    constructor(key) {
        if (!key) {
            throw new Error('Key must be specified for the facet');
        }
        this.entry = {
            facetKey: {
                key,
            },
        };
    }
    orderBy(value) {
        this.entry.facetKey.orderBy = value;
        return this;
    }
    intervals(intervals) {
        if (this.entry.facetKey.intervals && this.entry.facetKey.intervals.length) {
            throw new Error('intervals have already been added to this facet');
        }
        this.entry.facetKey.intervals = intervals;
        return this;
    }
    excludedFilterKeys(...keys) {
        this.entry.excludedFilterKeys = keys;
        return this;
    }
    enableDynamicPosition(value = true) {
        this.entry.enableDynamicPosition = value;
        return this;
    }
    build() {
        return Object.assign({}, this.entry);
    }
}
exports.ListingsRequestFacetBuilder = ListingsRequestFacetBuilder;
